import type { CSSProperties } from 'react';

import { cn } from '@/shared/lib/utils';

interface FieldLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * Field label primitive in the Phoenix style — `text-phx-sm` muted-2 label
 * with an optional required asterisk.
 */
export function FieldLabel({
  htmlFor,
  children,
  required,
  disabled,
  className,
  style,
}: FieldLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      style={style}
      className={cn(
        'phx-label text-phx-sm text-phx-text-2 font-medium select-none',
        disabled && 'cursor-not-allowed opacity-70',
        className
      )}
    >
      {children}
      {required && (
        <span aria-hidden className="text-phx-danger ml-0.5">
          *
        </span>
      )}
    </label>
  );
}
